import { toast } from "react-toastify";
import { SOLICITUDES_API } from "../views/MainLayout/components/shared/services/solicitudes";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialSolicitudes = []

export const solicitudesReducer = (state = initialSolicitudes, action) => {
    switch(action.type){
        case "solicitudes/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchSolicitudes = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await SOLICITUDES_API.get(page, search)
        const data = await response.data;
        dispatch({ type: 'solicitudes/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}